import axios from 'axios';
import { GET_VEHICLE_REVIEW_SCORE, apiConfig } from './constants';
import { ReviewScoreResponse } from '../type';

/**
 * Function to fetch the review score for a vehicle
 * @param {string} capId of the vehicle
 */
export const getReviewScore = (capId: string | undefined) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get<string, ReviewScoreResponse>(
          GET_VEHICLE_REVIEW_SCORE(capId),
          apiConfig
        )
        .then((res) => {
          const { data } = res;
          resolve(data);
        })
        .catch(() => {
          reject('Error in getReviewScore axios.');
        });
    } catch (error) {
      console.error('in vehicleService > getReviewScore, Err===', error);
      reject('System error. Please try again later.');
    }
  });
};
